module.exports = __webpack_public_path__ + "5160bc3544138f43f367c8071a3a6e8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/adapter2.jpg
// module id = 162
// module chunks = 0